import {LoanB2CEntity} from './LoanB2CEntity.js'
import {LoanCalculationsB2CTransactionsEntity} from './LoanCalculationsB2CTransactionsEntity.js'
import {ReservationEntity} from './ReservationEntity.js'
import {TransactionEntity} from './TransactionEntity.js'
import {WalletEntity} from './WalletEntity.js'

export class TransactionsEntityFactory {
  static walletEntity = ({id, userId, iban, amount, thirdPartyId, provider}) =>
    new WalletEntity({id, userId, iban, amount, thirdPartyId, provider})

  static transactionEntity = ({
    id,
    adId,
    sellerId,
    buyerId,
    vehicleId,
    status,
    sellerWallet,
    buyerWallet,
    vehiclePrice,
    creationDate,
    updatedDate
  }) =>
    new TransactionEntity({
      id,
      adId,
      sellerId,
      buyerId,
      vehicleId,
      status,
      sellerWallet: this.walletEntity(sellerWallet),
      buyerWallet: this.walletEntity(buyerWallet),
      vehiclePrice,
      creationDate,
      updatedDate
    })

  static loanB2CEntity = ({loanId, loanUrl}) =>
    new LoanB2CEntity({
      loanId,
      loanUrl
    })

  static reservationEntity = ({
    reservationId,
    id = '',
    tenant = '',
    createdAt = '',
    externalRedirectUri = '',
    modifiedAt = '',
    adId = '',
    buyerId = '',
    buyerName = '',
    buyerLastName = '',
    email = '',
    phone = '',
    zipCode = '',
    externalReference = '',
    status = '',
    conversationId = '',
    rejectionReason = '',
    appointmentMessage = ''
  }) =>
    new ReservationEntity({
      reservationId,
      id,
      tenant,
      createdAt,
      externalRedirectUri,
      modifiedAt,
      adId,
      buyerId,
      buyerName,
      buyerLastName,
      email,
      phone,
      zipCode,
      externalReference,
      status,
      conversationId,
      rejectionReason,
      appointmentMessage
    })

  static loanCalculationsB2CTransactionsEntity = data => new LoanCalculationsB2CTransactionsEntity(data)
}
